import React from 'react';
import TextInfo, {
  COLOR,
  FONT_TYPE,
  SIZE,
  KIND_TEXT,
  SEGMENT,
  ALIGN,
  HEADING_LEVEL,
} from '@bit/gerenciatd.unifiedcomponents.text-info';
import SvgIconLoader, { SVG_ICON_KIND } from '@bit/gerenciatd.unifiedicons.svg-icon-loader';
import { generateBgAdvantage, giveRandomNumber } from './securityBenefitsUtils';
import './SecurityBenefits.scss';

const SecurityBenefits = ({ components, backgroundImg }) => {
  if (components.length > 0) {
    const idSecurityBenefits = `SecurityBenefits${giveRandomNumber(0, 1000)}`;
    if (backgroundImg) {
      generateBgAdvantage(idSecurityBenefits, backgroundImg);
    }

    return (
      <section id={idSecurityBenefits} className={`SecurityBenefits ${backgroundImg ? 'SecurityBenefits_bgImgCover' : 'SecurityBenefits_bgColor'}`}>
        <div className="icons-container container">
          {components.map(component => (
            <div className="icon-container" key={component.title}>
              <div className="icon-container_icon">
                <SvgIconLoader
                  kind={SVG_ICON_KIND.LIGHT}
                  color={COLOR.WHITE}
                  segment={SEGMENT.EMP}
                  backgroundColor={COLOR.TRANSPARENT}
                  size={72}
                  id={component.icon}
                />
              </div>
              <div className="icon-container_wrapper">
                <TextInfo
                  kind={KIND_TEXT.HEADING}
                  level={HEADING_LEVEL.H4}
                  align={ALIGN.CENTER}
                  size={SIZE.TITLE45}
                  fontType={FONT_TYPE.REGULAR}
                  color={COLOR.WHITE}
                  text={component.title}
                  segment={SEGMENT.EMP}
                  className="icon-container_wrapper_title"
                />
                <TextInfo
                  kind={KIND_TEXT.PARAGRAPH}
                  align={ALIGN.CENTER}
                  size={SIZE.CAPTION1}
                  fontType={FONT_TYPE.REGULAR}
                  color={COLOR.WHITE}
                  text={component.text}
                  segment={SEGMENT.EMP}
                  className="icon-container_wrapper_text"
                />
              </div>
            </div>
          ))}
        </div>
      </section>
    );
  }
  return null;
};

export default SecurityBenefits;
